import { ConnectForm } from "@/components/ConnectForm";
import { NewsletterForm } from "@/components/NewsletterForm";
import { Seo } from "@/components/Seo";

const INQUIRY_TYPES = [
  "Keynote & Talent Bookings",
  "Coaching — Speaker / Artist / Business Development",
  "Consulting & Business Development",
  "Creative Collaborations & Programming",
  "Podcast Inquiries",
  "General Contact",
];

const ConnectPage = () => {
  return (
    <>
      <Seo
        title="Connect — #whatshesaidproject"
        description="Book talent, inquire about coaching and consulting, propose creative collaborations, or reach out about the podcast — start an inquiry with #whatshesaidproject."
        path="/connect"
      />
    <section className="bg-[#121212] text-white py-24 md:py-32" data-testid="connect-page">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-3">
              Connect
            </span>
            <h1 className="font-disp text-[clamp(36px,5vw,64px)] leading-[1.05] tracking-tight font-normal text-white mb-6">
              Let us move culture together.
            </h1>
            <p className="text-[17px] text-[#aaaaaa] leading-relaxed mb-8">
              Whether you are an artist seeking coaching and representation, or an organization
              booking keynote talent, initiate an inquiry below.
            </p>
            <ul className="space-y-4 text-xs font-mono uppercase tracking-[.14em] text-[#b5b5b5]">
              {INQUIRY_TYPES.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-[#e02020]" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7 bg-[#1c1c1c] border border-[#2e2e2e] p-8 md:p-10">
            <ConnectForm />
          </div>
        </div>

        <div className="mt-24 pt-12 border-t border-[#2e2e2e] grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="font-disp text-2xl text-white mb-3">The Dispatch</h2>
            <p className="text-sm text-[#aaaaaa] leading-relaxed">
              Occasional essays, programming releases, talent announcements, and event invitations.
            </p>
          </div>
          <NewsletterForm />
        </div>
      </div>
    </section>
    </>
  );
};

export default ConnectPage;
